define([
	"dojo/_base/declare",
	"csi/def",
	"csi/heading/Ref",
	"csi/prefs",
	"csi/xml"
], function(declare, def, Ref, prefs, xml) {

	return declare(Ref, {

		getStore: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*Boolean*/bAll) {
			// summary: return shared custom views for data sheet - default parent type to Style for DataPackageTemplate
			const node = ctx.getNode();
			let viewId = "CoverSheet";
			const type = (node.$Type == "DataPackageTemplate") ? xml.enumGetText(node.TemplateType) : ctx.getParent().$Type;
			h.m_relationship = prefs.getStoreRelationship(def.composeViewKey(viewId, "DataPackage", type));
			return this.inherited(arguments);
		}
	});
});